import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';
export function getDataFiltros(ETipoFiltro, Anio, Modelo) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/FiltroBuscarCodigoProducto";
    switch (ETipoFiltro) {
        case data.FiltroPedito.ComboAnio:
            params.data = {
                'dto.ETipoFiltro': ETipoFiltro,
                'dto.Sistema': data.Sistema
            };
            break;
        case data.FiltroPedito.ComboModelo:
            params.data = {
                'dto.ETipoFiltro': ETipoFiltro,
                'dto.Anio': Anio,
                'dto.Sistema': data.Sistema
            };
            break;
        case data.FiltroPedito.ComboVehiculo:
            params.data = {
                'dto.ETipoFiltro': ETipoFiltro,
                'dto.Anio': Anio,
                'dto.Modelo': Modelo,
                'dto.Sistema': data.Sistema
            };
            break;
        default:
            break;
    }
    return ServiceManager.prototype.Post(params);
}
export function BuscarSistemaPrincipal(
    CodigoDealer, Vkorg, CorreoElectronicoDealer,
    Linkpdf, Catalogo, Centro,
    Moneda, Poblacion, Pagenumber) {
    const DispositivoId = getDevice();
    let params = {};


    params.url = "dealer/BuscarSistemaPrincipal";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.Vkorg': Vkorg,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Linkpdf': Linkpdf,
        'dto.Catalogo': Catalogo,
        'dto.Centro': Centro,
        'dto.Moneda': Moneda,
        'dto.Poblacion': Poblacion,
        'dto.Pagenumber': Pagenumber,
        'dto.Pagesize': data.PageSizeBuscadorCodigo,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function BuscarPedidoMasivo(Dealer, Linea, Asociado, PageNumber, file, format64) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/GenerarPedidoMasivo";
    params.data = {
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.Poblacion': Asociado.poblacion,
        'dto.Vkorg': Linea.vkorg,
        'dto.Waers': Asociado.moneda,
        'dto.Werks': Linea.centro,
        'dto.PageNumber': PageNumber,
        'dto.Almacen': Asociado.almacen,
        'dto.File': file,
        'dto.Sistema': data.Sistema,
        'dto.Format64': format64
    };
    console.log("params.data====>", params.data);
    return ServiceManager.prototype.Post(params);

}


export function BuscarSistema(CodigoDealer, Vkorg, CorreoElectronicoDealer,
    Linkpdf, Catalogo, Pagenumber) {
    const DispositivoId = getDevice();

    let params = {};
    params.url = "dealer/BuscarSistema";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.Vkorg': Vkorg,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Linkpdf': Linkpdf,
        'dto.Catalogo': Catalogo,
        'dto.Pagenumber': Pagenumber,
        'dto.Pagesize': data.PageSizeRepuestos,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function ListarSistemaRepuestos(Catalogo, Linkimg, Moneda,
    Pagina, Poblacion, Sistemaweb,
    CodigoDealer, CorreoElectronicoDealer,
    VKorg, Pagenumber) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarSistemaRepuestos";
    params.data = {
        'dto.Catalogo': Catalogo,
        'dto.Linkimg': Linkimg,
        'dto.Moneda': Moneda,
        'dto.Pagina': Pagina,
        'dto.Poblacion': Poblacion,
        'dto.Sistemaweb': Sistemaweb,
        'dto.CodigoDealer': CodigoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Pagenumber': Pagenumber,
        'dto.VKorg': VKorg,
        'dto.Pagesize': data.PageSizeRepuestos,
        'dto.Sistema': data.Sistema
    };
    console.log("ListarSistemaRepuestos==>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function BuscarCodigoDescripcionPrincipal(Centro, CodigoDealer,
    IMaterial, Moneda, Vkorg,
    Poblacion, CorreoElectronicoDealer,
    Pagenumber, Pantalla, Etiqueta) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarCodigoProductoPrincipal";
    params.data = {
        'dto.IBusExacta': 'NO',
        'dto.Centro': Centro,
        'dto.CodigoDealer': CodigoDealer,
        'dto.IMaterial': IMaterial.toUpperCase(),
        'dto.Moneda': Moneda,
        'dto.Vkorg': Vkorg,
        'dto.Poblacion': Poblacion,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Pagenumber': Pagenumber,
        'dto.Sistema': data.Sistema,
        'dto.Pagesize': data.PageSizeBuscadorCodigo,
        'dto.Pantalla': Pantalla,
        'dto.Etiqueta': Etiqueta
    };
    console.log("params.data===>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function BuscarKit(Dealer, Linea, Matnr) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarKit";
    params.data = {
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.Linea': Linea.linea,
        'dto.Matnr': Matnr,
    };
    console.log("BuscarKit====>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function BuscarCodigoDescripcion(Centro, CodigoDealer,
    IMaterial, Moneda, Vkorg,
    Poblacion, CorreoElectronicoDealer,
    Pagenumber, Pantalla, Etiqueta) {
    const DispositivoId = getDevice();

    let params = {};
    params.url = "dealer/BuscarCodigoProducto";
    params.data = {
        'dto.IBusExacta': 'NO',
        'dto.Centro': Centro,
        'dto.CodigoDealer': CodigoDealer,
        'dto.IMaterial': IMaterial,
        'dto.Moneda': Moneda,
        'dto.Vkorg': Vkorg,
        'dto.Poblacion': Poblacion,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Pagenumber': Pagenumber,
        'dto.Pagesize': data.PageSizeBuscadorCodigo,
        'dto.Sistema': data.Sistema,
        'dto.Pantalla': Pantalla,
        'dto.Etiqueta': Etiqueta
    };
    console.log("BuscarCodigoDescripcion==>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function GetPdfFilePedidoPedido(codigoPedido) {
    let params = {};
    params.url = "dealer/GetPdfPedido";
    params.data = {
        'dto.Codigo': codigoPedido
    };

    return ServiceManager.prototype.Post(params);
}

export function ListarEstadosPedido(CodigoDealer, CorreoElectronicoDealer, VKorg, tipo) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarEstadosPedido";
    params.data = {
        'dto.DispositivoDealer': DispositivoId,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.VKorg': VKorg,
        'dto.ITipop': tipo,
        'dto.Sistema': data.Sistema
    };

    return ServiceManager.prototype.Post(params);
}

export function ListarHistorialPedido(VKorg, Estado, CodigoDealer, CorreoElectronicoDealer, tipo) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarHistorialPedido";
    params.data = {
        'dto.VKorg': VKorg,
        'dto.IEstad': Estado,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.ITipop': tipo,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function ListarHistorialPedidoTodos(VKorg, Pedido, CodigoDealer, CorreoElectronicoDealer, tipo) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarHistorialPedidoTodos";
    params.data = {
        'dto.VKorg': VKorg,
        'dto.IVbeLn': Pedido,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.ITipop': tipo,
        'dto.Sistema': data.Sistema
    };
    console.log("ListarHistorialPedidoTodos params", params.data);
    return ServiceManager.prototype.Post(params);
}

export function ListarDetallePedido(kunnr, CodigoDealer, CorreoElectronicoDealer) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarDetallePedido";
    params.data = {
        'dto.IVbeln': kunnr,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function ListarTrakingPedido(kunnr, CodigoDealer, CorreoElectronicoDealer, tipo, serie, numer, cdvped) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarTrakingPedido";
    params.data = {
        'dto.IVbeln': kunnr,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Tipod': tipo,
        'dto.Serie': serie,
        'dto.Numer': numer,
        'dto.Cdvped': cdvped,
        'dto.Sistema': data.Sistema
    };
    console.log("params.data===>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function FiltroBuscarPedidoSugerido(Vkorg, Linea, CodigoDealer, CorreoElectronicoDealer) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/FiltroBuscarPedidoSugerido";
    params.data = {
        'dto.VKorg': Vkorg,
        'dto.Linea': Linea,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function BuscarPedidoSugerido(Vkorg, Linea, CodigoDealer, CorreoElectronicoDealer, Dest,
    Pobla, Waers, PageNumber, PageZise, Sistema) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarPedidoSugerido";
    params.data = {
        'dto.VKorg': Vkorg,
        'dto.Linea': Linea,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Dest': Dest,
        'dto.Pobla': Pobla,
        'dto.Waers': Waers,
        'dto.PageNumber': PageNumber,
        'dto.Pagesize': PageZise,
        'dto.Sistema': Sistema
    };

    return ServiceManager.prototype.Post(params);
}

export function BuscarProductoMasComprado(Vkorg, CodigoDealer, CorreoElectronicoDealer, Pobla, Waers, Werks) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarProductoMasComprado";
    params.data = {
        'dto.VKorg': Vkorg,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Pobla': Pobla,
        'dto.Waers': Waers,
        'dto.Werks': Werks,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function BuscarProductoDestacado(Vkorg, CodigoDealer, CorreoElectronicoDealer, Pobla, Waers, Werks) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarProductoDestacado";
    params.data = {
        'dto.VKorg': Vkorg,
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Pobla': Pobla,
        'dto.Waers': Waers,
        'dto.Werks': Werks,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function BuscarProductoOfertas(Vkorg, CodigoDealer, CorreoElectronicoDealer,
    Pobla, Waers, Werks,
    sistema, size, page,
    IMaterial, Pantalla, Etiqueta) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarCodigoProducto";

    params.data = {
        'dto.IBusExacta': 'NO',
        'dto.Proceso': 'O',
        'dto.Centro': Werks,
        'dto.CodigoDealer': CodigoDealer,
        'dto.IMaterial': (IMaterial == "" || IMaterial == null) ? "*" : IMaterial.toUpperCase(),
        'dto.Moneda': Waers,
        'dto.Vkorg': Vkorg,
        'dto.Poblacion': Pobla,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.Pagenumber': page,
        'dto.Pagesize': size,
        'dto.Sistema': sistema,
        // 'dto.Pantalla': Pantalla,
        // 'dto.Etiqueta': Etiqueta,
    };
    console.log("BuscarCodigoProducto=====>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function BuscarPrePedido(Dealer, Linea, Asociado) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarPrePedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function AbrirPrePedido(Dealer, PedidoId) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/AbrirPrePedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.PedidoId': PedidoId,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}